import Step6 from '@/Classes/FollowUp/FollowUpPatint';
export default {
  data() {
    return {
      patientMedicalHistoriesTypeList: [
        { title: 'بیماری های تنفسی', id: 1 },
        { title: 'بیماری های قلبی عروقی', id: 2 },
        { title: 'تغییرات فشار خون', id: 3 },
        { title: 'دیابت', id: 4 },
        { title: 'اختلال رفتاری', id: 5 },
        { title: 'سوء مصرف مواد', id: 6 },
        { title: 'بیماری های گوارشی', id: 7 },
        { title: 'بیماری های عفونی', id: 8 },
        { title: 'تشنج', id: 9 },
        { title: 'سابقه بدخیمی', id: 10 },
        { title: 'CVA', id: 11 },
        { title: 'سابقه جراحی اخیر', id: 12 },
        { title: 'بیماری های کلیوی', id: 13 },
        { title: 'بیماری های خاص', id: 14 },
        { title: 'اوتیسم', id: 15 },
        { title: 'ناشنوایان', id: 16 },
      ],
      patientMedicalHistoriesTypeList_3: [
        { title: 'بیماری های تنفسی', id: 1 },
        { title: 'بیماری های قلبی عروقی', id: 2 },
        { title: 'تغییرات فشار خون', id: 3 },
        { title: 'دیابت', id: 4 },
        { title: 'اختلال رفتاری', id: 5 },
        { title: 'سوء مصرف مواد', id: 6 },
        { title: 'بیماری های گوارشی', id: 7 },
        { title: 'بیماری های عفونی', id: 8 },
        { title: 'تشنج', id: 9 },
        { title: 'سابقه بدخیمی', id: 10 },
        { title: 'CVA', id: 11 },
        { title: 'سابقه جراحی اخیر', id: 12 },
        { title: 'بیماری های کلیوی', id: 13 },
        { title: 'بیماری های خاص', id: 14 },
        { title: 'اوتیسم', id: 15 },
        { title: 'ناشنوایان', id: 16 },
      ],
      patientMedicalHistoriesTypeList_5: [
        { title: 'بیماری های تنفسی', id: 1 },
        { title: 'بیماری های قلبی عروقی', id: 2 },
        { title: 'تغییرات فشار خون', id: 3 },
        { title: 'دیابت بارداری', id: 17 },
        { title: 'دیابت', id: 4 },
        { title: 'مسمومیت بارداری', id: 18 },
        { title: 'سابقه چندقلویی', id: 19 },
        { title: 'اختلال رفتاری', id: 5 },
        { title: 'سوء مصرف مواد', id: 6 },
        { title: 'بیماری های گوارشی', id: 7 },
        { title: 'بیماری های عفونی', id: 8 },
        { title: 'تشنج', id: 9 },
        { title: 'سابقه بدخیمی', id: 10 },
        { title: 'CVA', id: 11 },
        { title: 'سابقه جراحی اخیر', id: 12 },
        { title: 'بیماری های کلیوی', id: 13 },
        { title: 'بیماری های خاص', id: 14 },
        { title: 'اوتیسم', id: 15 },
        { title: 'ناشنوایان', id: 16 },
      ],
      mainPatientMedicalHistoriesTypeList: [
        { title: 'بیماری های تنفسی', id: 1 },
        { title: 'بیماری های قلبی عروقی', id: 2 },
        { title: 'تغییرات فشار خون', id: 3 },
        { title: 'دیابت بارداری', id: 17 },
        { title: 'دیابت', id: 4 },
        { title: 'مسمومیت بارداری', id: 18 },
        { title: 'سابقه چندقلویی', id: 19 },
        { title: 'اختلال رفتاری', id: 5 },
        { title: 'سوء مصرف مواد', id: 6 },
        { title: 'بیماری های گوارشی', id: 7 },
        { title: 'بیماری های عفونی', id: 8 },
        { title: 'تشنج', id: 9 },
        { title: 'سابقه بدخیمی', id: 10 },
        { title: 'CVA', id: 11 },
        { title: 'سابقه جراحی اخیر', id: 12 },
        { title: 'بیماری های کلیوی', id: 13 },
        { title: 'بیماری های خاص', id: 14 },
        { title: 'اوتیسم', id: 15 },
        { title: 'ناشنوایان', id: 16 },
      ],

      selectedPatientMedicalHistoriesTypeList: [],
      patientMedicalHistory: new Step6.Step6('', null),
      otherPatientMedicalHistory: '',
    };
  },
  methods: {
    addOtherPatientMedicalHistory: function () {
      if (!this.otherPatientMedicalHistory) {
        this.showErrorAlert('سایر نمی تواند خالی باشد');
        return;
      }
      if (!this.otherPatientMedicalHistory.replace(/\s/g, '').length) {
        this.showErrorAlert('سایر نمی تواند خالی باشد');
        return;
      }
      this.addPatientMedicalHistoryTrumaType(this.otherPatientMedicalHistory);
    },
    addPatientMedicalHistoryTrumaType: function (title) {
      this.patientMedicalHistory.title = title;
      this.patientMedicalHistory.patientId = this.patientId;
      this.addPatientMedicalHistoryFunction(this.patientMedicalHistory);
    },
    patientMedicalHistoryTrumaTypeAdded: function () {
      this.otherPatientMedicalHistory = '';
    },
    setData: function (data) {
      this.selectedPatientMedicalHistoriesTypeList = [];
      for (let i = 0; i < data.length; i++) {
        let flag = false;
        for (let j = 0; j < this.patientMedicalHistoriesTypeList.length; j++) {
          if (data[i].title == this.patientMedicalHistoriesTypeList[j].title) {
            flag = true;
            this.selectedPatientMedicalHistoriesTypeList.push(data[i]);
            this.patientMedicalHistoriesTypeList.splice(j, 1);
          }
        }
        if (!flag) {
          this.selectedPatientMedicalHistoriesTypeList.push(data[i]);
        }
      }
    },
    removeItem: function (title) {
      for (let i = 0; i < this.mainPatientMedicalHistoriesTypeList.length; i++) {
        if (title == this.mainPatientMedicalHistoriesTypeList[i].title) {
          this.patientMedicalHistoriesTypeList.push({
            title: title,
            id: this.patientMedicalHistoriesTypeList.length + 1,
          });
        }
      }
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(3, true);
    },
    backToStep4: function () {
      this.$root.$refs.FollowUpPatient.changeTab2Step(1, true);
    },
  },
};
